// extracted by mini-css-extract-plugin
export var addToCartButton = "_q1-b";
export var arrowButtonContainer = "_q1-9";
export var arrowButtonIcon = "_q1-a";
export var carouselArrowButton = "_q1-6";
export var carouselElementContainer = "_q1-1";
export var left = "_q1-7";
export var productDisplayCarouselContainer = "_q1-0";
export var productTileContainer = "_q1-2";
export var productTileImage = "_q1-4";
export var productTileImageContainer = "_q1-3";
export var productTileTitle = "_q1-5";
export var right = "_q1-8";
export var sliderOverflow = "_q1-c";